(function () {
    "use strict";

    class ControllerDecorator {
        constructor(commonServices, downloadService, commonFunctions, externalDependencies, $filter, guid) {
            this.services = commonServices;
            this.downloader = downloadService;
            this.utils = commonFunctions;
            this.external = externalDependencies;
            this.getTranslation = $filter("habilTranslation");
            this.guid = guid;
            
        }

        extras = {
            "files": this.addFileHandling,
        };

        Decorate(controller, features) {
            Object.assign(controller, { guid: this.guid });
            this.defaultMethods(controller);
            this.addOptionalFeatures(features, controller);
        }

        addOptionalFeatures(features, controller) {
            if (!Array.isArray(features))
                return;

            for (const feature of features) {
                switch (feature.toLowerCase()) {
                    case "files":
                        this.addFileHandling(controller);
                        break;
                    case "dialog":
                        this.addDialogHandling(controller);
                        break;
                    case "navigation":
                        this.addNavigation(controller);
                        break;
                    case "comments":
                        this.addComments(controller);
                        break;
                }
            }
        }

        defaultMethods(controller) {
            controller.Api = this.services.Api;
            controller.Settings = this.services.Settings;
            controller.Utils = this.utils;

            controller.ParseUrl = this.services.HabilUrlParser.Parse;
            controller.ParsePrettyUrl = this.services.HabilUrlParser.ParsePretty;

            controller.SetLoadingState = this.services.LoadingIndicator.SetLoadingState;
            controller.ShowError = error => DoShowError(this.services.Notifications, error);
            controller.ShowSuccess = message => this.services.Notifications.success(message);
            controller.ShowNotice = message => this.services.Notifications.warning(message);

            controller.getTranslation = this.getTranslation;
        }

        addFileHandling(controller) {
            controller.File = {
                Download: this.downloader.DownloadAttachment,
                DownloadByPublicId: this.downloader.DownloadAttachmentByPublicId,
                Save: this.downloader.SaveResult,
                saveExport: this.downloader.saveExport,
                DownloadBVL: this.downloader.DownloadBVL,
                DownloadCertificate: this.downloader.DownloadCertificate
            };
        }

        addDialogHandling(controller) {
            controller.Dialog = {
                Custom: (options) => this.external.Bootbox.customDialog(options),
                Prompt: this.external.Bootbox.prompt,
                Alert: this.external.Bootbox.alert,
                Confirm: this.external.Bootbox.confirm,
                CloseAll: this.external.Bootbox.hideAll,
            };
        }

        addNavigation(controller) {
            controller.Navigator = this.services.Navigator;
        }

        addComments(controller) {
            controller.Comments = this.services.Comments;
        }
    }

    ControllerDecorator.$inject = ["commonServices", "downloadService", "commonFunctions", "externalDependencies", "$filter", "guid"];

    // eslint-disable-next-line angular/no-service-method
    angular.module("app").service("controllerDecorator", ControllerDecorator);
})();
